import { render, staticRenderFns } from "./view_mode.vue?vue&type=template&id=0c376af7&scoped=true"
import script from "./view_mode.vue?vue&type=script&lang=js"
export * from "./view_mode.vue?vue&type=script&lang=js"
import style0 from "./view_mode.vue?vue&type=style&index=0&id=0c376af7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c376af7",
  null
  
)

export default component.exports